<template>
        <div class="contact-w3-agile1 map" data-aos="flip-right">
		   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1629.559744599176!2d60.634618073108484!3d35.22839542700963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f15b5a661fbcd43%3A0x9f89c606a3f1b44c!2zUmF6YXZpIEtob3Jhc2FuIFByb3ZpbmNlLCBUb3JiYXQtZSBKYW0sINiu24zYp9io2KfZhiDYtNmH24zYryDYudio2KfYs9m-2YjYsdiMIElyYW4!5e0!3m2!1sen!2sin!4v1648630160346!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
	   </div>
</template>

<script>
export default {
name:"MapIfram"
}
</script>

<style>

</style>